import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledBox= styled(Box)({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "end",
    marginBottom: "20px",
    ".topBox" :{
        display: "flex",
        ".box1":{
            marginRight: "15px"
        },
       
    }
});
export const MyFilterBox = ({ children, ...otherProp }) => {
  return <StyledBox {...otherProp}>{children} </StyledBox>;                     
};
